import React, {useEffect, useState} from 'react'
import {
  getConfigurationByName,
  updateConfigurationByConfigID,
} from '../../../../../../API/api-endpoint'
import ToastUtils, {ErrorToastUtils} from '../../../../../../utils/ToastUtils'
import {S3Client, ListBucketsCommand, HeadBucketCommand} from '@aws-sdk/client-s3'

const StoragePlugin = () => {
  const [configID, setConfigId] = useState(0)
  const [config, setConfig] = useState<any>({
    storage_type: 'local',
    wasabi_endpoint: '',
    wasabi_region: '',
    wasabi_access_key: '',
    wasabi_secret_key: '',
    wasabi_bucket_name: '',
    wasabi_cdn_url: '',
    enableProdBackup: false,
    enableDevBackup: false,
    aws_cdn_url: '',
    aws_endpoint: '',
    aws_region: '',
    aws_access_key: '',
    aws_secret_key: '',
    aws_bucket_name: '',
  })
  const [isTesting, setIsTesting] = useState(false)

  useEffect(() => {
    getConfiguration()
  }, [])

  const handleChange = (event: any) => {
    let name = event.target.name
    let value = event.target.value

    if (name === 'enableDevBackup' || name === 'enableProdBackup') {
      setConfig({...config, [name]: event.target.checked})
      updateConfiguration({...config, [name]: event.target.checked})
    } else {
      setConfig({...config, [name]: value})
    }
  }

  const onBlurUpdate = () => {
    updateConfiguration(config)
  }

  const getConfiguration = async () => {
    let result = await getConfigurationByName('storage_setting')
    if (result.success) {
      let parsedData = result.data.values
      setConfigId(result.data._id)
      setConfig({
        storage_type: parsedData?.storage_type,
        wasabi_endpoint: parsedData?.wasabi_endpoint,
        wasabi_region: parsedData?.wasabi_region,
        wasabi_access_key: parsedData?.wasabi_access_key,
        wasabi_secret_key: parsedData?.wasabi_secret_key,
        wasabi_bucket_name: parsedData?.wasabi_bucket_name,
        wasabi_cdn_url: parsedData?.wasabi_cdn_url,
        enableProdBackup: parsedData?.enableProdBackup,
        enableDevBackup: parsedData?.enableDevBackup,
        aws_cdn_url: parsedData?.aws_cdn_url,
        aws_endpoint: parsedData?.aws_endpoint,
        aws_region: parsedData?.aws_region,
        aws_access_key: parsedData?.aws_access_key,
        aws_secret_key: parsedData?.aws_secret_key,
        aws_bucket_name: parsedData?.aws_bucket_name,
      })

      let URL = ''
      if (parsedData?.storage_type === 'local') {
        URL = process.env.REACT_APP_SERVER_URL || ''
      } else if (parsedData?.storage_type === 'wasabi') {
        URL = parsedData?.wasabi_endpoint + '/' + parsedData?.wasabi_bucket_name
      } else if (parsedData?.storage_type === 'aws') {
        URL = parsedData?.aws_cdn_url
      }

      localStorage.setItem('baseUrl', URL)
    }
  }

  const updateConfiguration = async (config: any) => {
    let result = await updateConfigurationByConfigID(configID, config, null)
    if (result.success) {
      getConfiguration()
      ToastUtils({type: 'success', message: 'Configuration Saved SuccessFully'})
    } else {
      ErrorToastUtils()
    }
  }

  const testConnection = async (type) => {
    // Validate Wasabi configuration

    let config1 = {}

    if (type === 'wasabi') {
      config1 = {
        wasabi_endpoint: config?.wasabi_endpoint,
        wasabi_region: config?.wasabi_region,
        wasabi_access_key: config?.wasabi_access_key,
        wasabi_secret_key: config?.wasabi_secret_key,
        wasabi_bucket_name: config?.wasabi_bucket_name,
      }
    } else if (type === 'aws') {
      config1 = {
        aws_endpoint: config?.aws_endpoint,
        aws_region: config?.aws_region,
        aws_access_key: config?.aws_access_key,
        aws_secret_key: config?.aws_secret_key,
        aws_bucket_name: config?.aws_bucket_name,
      }
    }
    if (Object.values(config1).some((value: any) => !value?.trim())) {
      return ToastUtils({type: 'error', message: 'Fill All Details'})
    }
    setIsTesting(true)

    // Configure Wasabi S3 Client
    let s3Client
    if (type === 'wasabi') {
      s3Client = new S3Client({
        endpoint: config.wasabi_endpoint,
        region: config.wasabi_region,
        credentials: {
          accessKeyId: config.wasabi_access_key,
          secretAccessKey: config.wasabi_secret_key,
        },
      })
    } else if (type === 'aws') {
      s3Client = new S3Client({
        region: config.aws_region,
        credentials: {
          accessKeyId: config.aws_access_key,
          secretAccessKey: config.aws_secret_key,
        },
      })
    }

    try {
      //   await s3Client.send(new ListBucketsCommand({}))
      await s3Client.send(new HeadBucketCommand({Bucket: config?.aws_bucket_name}))
      ToastUtils({type: 'success', message: type + ' Connection is working successfully'})
      setIsTesting(false)
    } catch (error: any) {
      console.log('error', error)
      ToastUtils({type: 'error', message: `Connection failed: ${error.message}`})
      setIsTesting(false)
    }
  }

  return (
    <div className='card'>
      <div className='card-body'>
        <div className='row no-gutters'>
          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Storage Type</strong>
            </p>
            <p className='text-muted'>-</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='flex'>
              <select
                className='form-select form-select-solid fw-bolder'
                data-kt-select2='true'
                data-placeholder='Select option'
                data-allow-clear='true'
                defaultValue={config.storage_type}
                name='storage_type'
                value={config.storage_type}
                onChange={(event) => handleChange(event)}
                onBlur={onBlurUpdate}
              >
                <option value={'local'}>Local</option>
                <option value={'wasabi'}>Wasabi</option>
                <option value={'aws'}>AWS</option>
              </select>
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Enable Backup In Production</strong>
            </p>
            <p className='text-muted'>
              The folder name should start with: `db_backups/production` in wasabi
            </p>
            <p className='text-danger'>
              Even if the storage type is set to local, database backups will still be uploaded to
              Wasabi.
            </p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='form-check form-switch'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                id='flexSwitchCheckDefault'
                name='enableProdBackup'
                checked={config.enableProdBackup}
                onChange={(event) => handleChange(event)}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Enable Backup In Development</strong>
            </p>
            <p className='text-muted'>
              The folder name should start with: `db_backups/development` in wasabi
            </p>{' '}
            <p className='text-danger'>
              Even if the storage type is set to local, database backups will still be uploaded to
              Wasabi.
            </p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='form-check form-switch'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                id='flexSwitchCheckDefault'
                name='enableDevBackup'
                checked={config.enableDevBackup}
                onChange={(event) => handleChange(event)}
              />
            </div>
          </div>

          {/* {config.storage_type === 'wasabi' && ( */}
          <>
            <div className='col-lg-4 card-body bg-light'>
              <p>
                <strong className='headings-color'>Wasabi EndPoint</strong>
              </p>
              <p className='text-muted'>-</p>
            </div>
            <div className='col-lg-8 card-form__body card-body align-items-center bg-white'>
              <div className='flex'>
                <input
                  type='text'
                  className='form-control'
                  name='wasabi_endpoint'
                  value={config.wasabi_endpoint}
                  onChange={(event) => handleChange(event)}
                  onBlur={onBlurUpdate}
                />
              </div>
            </div>

            <div className='col-lg-4 card-body bg-light'>
              <p>
                <strong className='headings-color'>Wasabi CDN Url</strong>
              </p>
              <p className='text-muted'>-</p>
            </div>
            <div className='col-lg-8 card-form__body card-body align-items-center bg-white'>
              <div className='flex'>
                <input
                  type='text'
                  className='form-control'
                  name='wasabi_cdn_url'
                  value={config.wasabi_cdn_url}
                  onChange={(event) => handleChange(event)}
                  onBlur={onBlurUpdate}
                />
              </div>
            </div>

            <div className='col-lg-4 card-body bg-light'>
              <p>
                <strong className='headings-color'>Wasabi Region</strong>
              </p>
              <p className='text-muted'>-</p>
            </div>
            <div className='col-lg-8 card-form__body card-body align-items-center bg-white'>
              <div className='flex'>
                <input
                  type='text'
                  className='form-control'
                  name='wasabi_region'
                  value={config.wasabi_region}
                  onChange={(event) => handleChange(event)}
                  onBlur={onBlurUpdate}
                />
              </div>
            </div>

            <div className='col-lg-4 card-body bg-light'>
              <p>
                <strong className='headings-color'>Wasabi Access Key</strong>
              </p>
              <p className='text-muted'>-</p>
            </div>
            <div className='col-lg-8 card-form__body card-body align-items-center bg-white'>
              <div className='flex'>
                <input
                  type='text'
                  className='form-control'
                  name='wasabi_access_key'
                  value={config.wasabi_access_key}
                  onChange={(event) => handleChange(event)}
                  onBlur={onBlurUpdate}
                />
              </div>
            </div>

            <div className='col-lg-4 card-body bg-light'>
              <p>
                <strong className='headings-color'>Wasabi Secret Key</strong>
              </p>
              <p className='text-muted'>-</p>
            </div>
            <div className='col-lg-8 card-form__body card-body align-items-center bg-white'>
              <div className='flex'>
                <input
                  type='text'
                  className='form-control'
                  name='wasabi_secret_key'
                  value={config.wasabi_secret_key}
                  onChange={(event) => handleChange(event)}
                  onBlur={onBlurUpdate}
                />
              </div>
            </div>

            <div className='col-lg-4 card-body bg-light'>
              <p>
                <strong className='headings-color'>Wasabi Bucket Name</strong>
              </p>
              <p className='text-muted'>-</p>
            </div>
            <div className='col-lg-8 card-form__body card-body align-items-center bg-white'>
              <div className='flex'>
                <input
                  type='text'
                  className='form-control'
                  name='wasabi_bucket_name'
                  value={config.wasabi_bucket_name}
                  onChange={(event) => handleChange(event)}
                  onBlur={onBlurUpdate}
                />
              </div>
            </div>

            <div className='col-lg-4 card-body bg-light'></div>
            <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
              <button
                className='btn btn-primary'
                onClick={() => {
                  testConnection('wasabi')
                }}
                disabled={isTesting}
              >
                Test Wasabi Connection
              </button>
            </div>

            <div className='col-lg-4 card-body bg-light'>
              <p>
                <strong className='headings-color'>AWS EndPoint</strong>
              </p>
              <p className='text-muted'>-</p>
            </div>
            <div className='col-lg-8 card-form__body card-body align-items-center bg-white'>
              <div className='flex'>
                <input
                  type='text'
                  className='form-control'
                  name='aws_endpoint'
                  value={config.aws_endpoint}
                  onChange={(event) => handleChange(event)}
                  onBlur={onBlurUpdate}
                />
              </div>
            </div>

            <div className='col-lg-4 card-body bg-light'>
              <p>
                <strong className='headings-color'>AWS CDN URL</strong>
              </p>
              <p className='text-muted'>-</p>
            </div>
            <div className='col-lg-8 card-form__body card-body align-items-center bg-white'>
              <div className='flex'>
                <input
                  type='text'
                  className='form-control'
                  name='aws_cdn_url'
                  value={config.aws_cdn_url}
                  onChange={(event) => handleChange(event)}
                  onBlur={onBlurUpdate}
                />
              </div>
            </div>

            <div className='col-lg-4 card-body bg-light'>
              <p>
                <strong className='headings-color'>AWS Region</strong>
              </p>
              <p className='text-muted'>-</p>
            </div>
            <div className='col-lg-8 card-form__body card-body align-items-center bg-white'>
              <div className='flex'>
                <input
                  type='text'
                  className='form-control'
                  name='aws_region'
                  value={config.aws_region}
                  onChange={(event) => handleChange(event)}
                  onBlur={onBlurUpdate}
                />
              </div>
            </div>

            <div className='col-lg-4 card-body bg-light'>
              <p>
                <strong className='headings-color'>AWS Access Key</strong>
              </p>
              <p className='text-muted'>-</p>
            </div>
            <div className='col-lg-8 card-form__body card-body align-items-center bg-white'>
              <div className='flex'>
                <input
                  type='text'
                  className='form-control'
                  name='aws_access_key'
                  value={config.aws_access_key}
                  onChange={(event) => handleChange(event)}
                  onBlur={onBlurUpdate}
                />
              </div>
            </div>

            <div className='col-lg-4 card-body bg-light'>
              <p>
                <strong className='headings-color'>AWS Secret Key</strong>
              </p>
              <p className='text-muted'>-</p>
            </div>
            <div className='col-lg-8 card-form__body card-body align-items-center bg-white'>
              <div className='flex'>
                <input
                  type='text'
                  className='form-control'
                  name='aws_secret_key'
                  value={config.aws_secret_key}
                  onChange={(event) => handleChange(event)}
                  onBlur={onBlurUpdate}
                />
              </div>
            </div>

            <div className='col-lg-4 card-body bg-light'>
              <p>
                <strong className='headings-color'>AWS Bucket Name</strong>
              </p>
              <p className='text-muted'>-</p>
            </div>
            <div className='col-lg-8 card-form__body card-body align-items-center bg-white'>
              <div className='flex'>
                <input
                  type='text'
                  className='form-control'
                  name='aws_bucket_name'
                  value={config.aws_bucket_name}
                  onChange={(event) => handleChange(event)}
                  onBlur={onBlurUpdate}
                />
              </div>
            </div>

            <div className='col-lg-4 card-body bg-light'></div>
            <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
              <button
                className='btn btn-primary'
                onClick={() => {
                  testConnection('aws')
                }}
                disabled={isTesting}
              >
                Test Aws Connection
              </button>
            </div>
          </>
          {/* )} */}
        </div>
      </div>
    </div>
  )
}

export default StoragePlugin
